import styles from './InlineMessage.module.css';

export const InlineMessage = ({children, type}) => {
    return (
        <div className={`${styles[type]} ${styles.message}`}>{children}</div>
    );
}